/**
 * ip_cart-upsell.js — click handling for the cart drawer upsell
 * (snippets/ip_cart-upsell.liquid).
 *
 * Loaded once from snippets/header-actions.liquid. Uses document-level event
 * delegation because the drawer contents (including the upsell markup) are
 * re-rendered via section morphs on every cart change — inline scripts inside
 * that markup would never (re-)execute.
 */
(function () {
  if (window.__ipCartUpsellInit) return;
  window.__ipCartUpsellInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ip-upsell-add]');
    if (!btn || btn.disabled || btn.tagName === 'A') return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-ip-upsell-add');
    var wrapper = btn.closest('[data-ip-upsell]');
    btn.classList.add('ip-upsell--busy');

    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });

    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    if (sectionIds.length) {
      fd.append('sections', sectionIds.join(','));
      fd.append('sections_url', window.location.pathname);
    }

    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.status) throw new Error(json.description || json.message || 'Add to cart failed');
        // Fetch the full cart for an accurate total count, then let the theme's
        // cart-items-component morph the drawer from the returned sections.
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cartJson) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cartJson,
                sourceId: 'ip-cart-upsell',
                data: {
                  source: 'ip-cart-upsell',
                  itemCount: cartJson.item_count,
                  variantId: variantId,
                  sections: json.sections
                }
              }
            }));
          });
      })
      .catch(function (err) {
        console.error('[ip-cart-upsell]', err);
        btn.classList.remove('ip-upsell--busy');
        if (wrapper) {
          var msg = wrapper.querySelector('.ip-upsell__error');
          if (msg) {
            msg.hidden = false;
            setTimeout(function () { msg.hidden = true; }, 4000);
          }
        }
      });
  });
})();
